module.exports = __webpack_public_path__ + "static/media/OSG.810a8759.jpg";